module.exports = __webpack_public_path__ + "static/media/paymentcheck.82227c64.svg";